/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object, func, string, shape, bool,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getCurrentPageView } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Selectors';
import { getOperatingSystem } from '../../../../../state/ducks/App/ducks/Config/Config-Helpers';
import { getFeatureFlags, getCurrentBrandId } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { determineChatlink } from '../../../MultiBrandChatController/Global_chat_helpers';

const styles = (theme) => ({
    phoneBlock: {
        display: 'block',
        fontFamily: theme.typography.fontFamily,
    },
    heading: {
        textAlign: 'center',
        fontSize: '18px',
        color: 'black',
    },
    subHeading: {
        textAlign: 'center',
        fontSize: '14px',
        padding: '10px 0px',
        color: 'black',
    },
    chatIcon: {
        display: 'flex',
        flexDirection: 'column',
        alignItem: 'center',
        padding: '7.73832px 19.3458px',
        width: '132.18px',
        height: '35.48px',
        background: theme.palette.bgChatMessage,
        border: `0.96729px solid ${theme.palette.bgChatMessage} `,
        borderRadius: '2.90187px',
        flex: 'none',
        order: 0,
        alignSelf: 'stretch',
        flexGrow: 0,
        position: 'relative',
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        gap: '10px',
    },
    chatLayout: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0px',
        gap: '13.54px',
        width: '93.49px',
        height: '20px',
        flex: 'none',
        order: 0,
        flexGrow: 0,
    },
    liveChatText: {
        width: 'fit-content',
        height: '20px',
        // fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '12px',
        lineHeight: '19px',
        display: 'flex',
        alignItem: 'center',
        textAlign: 'center',
        letterSpacing: '0.025em',
        color: '#FFFFFF',
        flex: 'none',
        order: 1,
        flexGrow: 0,
    },
    phoneIcon: {
        '& img': {
            width: '18.38px',
            height: '20.44px',
            transform: 'matrix(1, 0, 0, 1, 0, 0)',
            color: theme.palette.bgHeader,
            flex: 'none',
            order: 0,
            flexGrow: 0,
        },
        '& svg': {
            fill: `${theme.palette.bgChatMessage}`,
        },
    },
    phoneBox: {
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '7.73832px 19.3458px',
        width: '132.18px',
        height: '35.48px',
        border: `0.96729px solid ${theme.palette.bgChatMessage}`,
        borderRadius: '2.90187px',
        flex: 'none',
        order: 0,
        alignSelf: 'stretch',
        flexGrow: 0,
        background: '#FFFFFF',
    },
    phoneLayout: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0px',
        gap: '13.54px',
        width: '74.93px',
        height: '20px',
        flex: 'none',
        order: 0,
        flexGrow: 0,
    },
    callUsText: {
        width: 'fit-content',
        height: '20px',
        // fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '12px',
        lineHeight: '19px',
        /* identical to box height, or 143% */
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        letterSpacing: '0.025em',
        color: theme.palette.bgChatMessage,
        flex: 'none',
        order: 1,
        flexGrow: 0,
    },
});

const CustomerServiceBlock = ({
    classes, phoneNumber, trackEvent, foodPresentation, pageView,
}) => {
    const operatingSystem = getOperatingSystem().toLowerCase();
    const featureFlags = useSelector((state) => getFeatureFlags(state));
    const customerData = useSelector((state) => state?.member);
    const currentBrand = useSelector((state) => getCurrentBrandId(state));
    const isPDP = (featureFlags['is-pdp-mobile-chat-enabled'] && typeof document !== 'undefined' && document?.querySelector("[data-pagetype='product']"));
    const isMobileChatEnabled = ((featureFlags['is-gbm-in-pwa-enabled'] && operatingSystem === 'android') || (featureFlags['is-abc-in-pwa-enabled'] && operatingSystem === 'ios'));
    const trackClickEvent = () => {
        if (foodPresentation) {
            trackEvent({
                eventCategory: 'HomePage',
                eventAction: 'Call',
                eventLabel: 'Homepage',
            });
        } else {
            trackEvent({
                eventCategory: 'Footer',
                eventAction: pageView?.pageType || '',
                eventLabel: 'Phone',
            });
        }
    };
    return (
        <>
            {
                featureFlags['is-global-cs-mobile-footer-enabled'] && !isPDP
                    ? (
                        <div id="footerChatRegion" className={classes.phoneBlock}>
                            <div className={classes.heading}>
                                Have Questions?
                            </div>
                            <div className={classes.subHeading}>
                                {/* // eslint-disable-next-line react/jsx-curly-brace-presence */}
                                {"We'll help you find answers"}
                            </div>
                            <div className={classes.subHeading}>
                                <div className={classes.container} style={!isMobileChatEnabled ? { justifyContent: 'center', paddingLeft: '0px' } : { hidden: false }}>
                                    {isMobileChatEnabled
                                        && (
                                            <a
                                                href={determineChatlink(operatingSystem, currentBrand, featureFlags, customerData)}
                                                onClick={() => trackEvent({
                                                    eventCategory: 'Mobile',
                                                    eventAction: 'Chat opened',
                                                    eventLabel: 'Chat',
                                                })}
                                                aria-hidden="true"
                                                tabIndex="-1"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <span className={classes.chatIcon}>
                                                    <span className={classes.chatLayout}>
                                                        <svg width="20" height="18" viewBox="0 0 20 18" fill="white" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M0.663788 4.78358C0.663788 2.65237 2.39148 0.924683 4.52269 0.924683H15.7486C17.8798 0.924683 19.6075 2.65237 19.6075 4.78358V10.0457C19.6075 12.1769 17.8798 13.9046 15.7486 13.9046H8.9078L5.599 17.2134C5.26714 17.5453 4.69975 17.3096 4.7007 16.8403L4.70668 13.9046H4.52269C2.39148 13.9046 0.663788 12.1769 0.663788 10.0457V4.78358ZM6.01362 8.81788C6.74017 8.81788 7.32916 8.2289 7.32916 7.50235C7.32916 6.7758 6.74017 6.18682 6.01362 6.18682C5.28707 6.18682 4.69809 6.7758 4.69809 7.50235C4.69809 8.2289 5.28707 8.81788 6.01362 8.81788ZM11.5389 7.50235C11.5389 8.2289 10.9499 8.81788 10.2233 8.81788C9.49678 8.81788 8.9078 8.2289 8.9078 7.50235C8.9078 6.7758 9.49678 6.18682 10.2233 6.18682C10.9499 6.18682 11.5389 6.7758 11.5389 7.50235ZM14.433 8.81788C15.1596 8.81788 15.7486 8.2289 15.7486 7.50235C15.7486 6.7758 15.1596 6.18682 14.433 6.18682C13.7065 6.18682 13.1175 6.7758 13.1175 7.50235C13.1175 8.2289 13.7065 8.81788 14.433 8.81788Z" />
                                                        </svg>
                                                        <span className={classes.liveChatText}>Live Chat</span>
                                                    </span>
                                                </span>
                                            </a>
                                        )}
                                    <span className={classes.phoneBox}>
                                        <a
                                            href={phoneNumber}
                                            onClick={() => trackClickEvent()}
                                            aria-hidden="true"
                                            tabIndex="-1"
                                            className={classes.phoneIcon}
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <span className={classes.phoneLayout}>
                                                <span className={classes.phoneIcon}>
                                                    <svg width="16" height="18" viewBox="0 0 16 18" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2.64677 11.1609C4.39136 14.1447 6.30067 15.9058 7.85219 16.9384C8.64625 17.4669 9.49775 17.4784 10.2416 17.1364C10.993 16.791 11.6433 16.0787 11.9874 15.1507C12.1105 14.8183 12.0816 14.4485 11.9079 14.1393L10.8538 12.2612C10.3822 11.421 9.36512 11.054 8.46492 11.3975L7.72891 11.6784C7.15889 11.896 6.46387 11.8543 5.98858 11.3885C5.24159 10.6565 4.72356 9.68068 4.4895 8.64547C4.33936 7.98137 4.66606 7.34519 5.17368 6.96298L5.83829 6.46258C6.61974 5.8742 6.84102 4.79703 6.35365 3.94892L5.27917 2.07915C5.10218 1.77117 4.80769 1.54837 4.46339 1.46135C3.488 1.21481 2.50396 1.33046 1.76691 1.7419C1.03774 2.14894 0.542657 2.8472 0.517511 3.80876C0.46956 5.6423 0.891774 8.15923 2.64677 11.1609Z" />
                                                        <path d="M10.0846 0.994192C9.81774 0.846261 9.4812 0.942194 9.33294 1.20846C9.18468 1.47474 9.28087 1.81051 9.54776 1.95843L9.9722 2.19373C12.6643 3.68594 14.4528 6.3995 14.7593 9.45688L14.7941 9.80416C14.8244 10.1072 15.0954 10.3283 15.3991 10.298C15.7029 10.2678 15.9246 9.99742 15.8942 9.69436L15.8594 9.34712C15.5168 5.93004 13.518 2.89724 10.5092 1.22949L10.0846 0.994192ZM8.78943 3.95021C8.94654 3.68902 9.28607 3.60432 9.54787 3.76104L9.68507 3.84318C11.4905 4.924 12.7301 6.74044 13.0763 8.81258L13.1255 9.10706C13.1756 9.40752 12.9722 9.69168 12.6711 9.74176C12.3699 9.79181 12.0851 9.58885 12.0349 9.2884L11.9857 8.99392C11.6928 7.24058 10.644 5.70359 9.11625 4.78905L8.97904 4.70691C8.71724 4.55019 8.63233 4.2114 8.78943 3.95021Z" />
                                                    </svg>
                                                </span>
                                                <span className={classes.callUsText}>Call Us</span>
                                            </span>
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    )
                    : null
            }
        </>
    );
};

CustomerServiceBlock.propTypes = {
    classes: object.isRequired,
    phoneNumber: string.isRequired,
    trackEvent: func.isRequired,
    foodPresentation: bool.isRequired,
    pageView: shape({
        pageType: string.isRequired,
    }).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});
const mapStateToProps = (state) => ({
    pageView: getCurrentPageView(state),
});

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
);

export default enhance(CustomerServiceBlock);
